import { Controller } from 'stimulus'
import { fireConfirmPopup, fireToast } from '../helpers'

export default class extends Controller {
  static targets = ['row', 'table']

  connect () {
    
  }

  check () {
    let dealRequirements = this.tableTarget.dataset.dealRequirements.split(',')
    for (let attachedFileRow of this.rowTargets) {
      let attachedFileRequirements = attachedFileRow.dataset.fileRequirements.split(',')
      let result = attachedFileRequirements.filter(e => !dealRequirements.find(a => e == a));
      if (result.length === 0 || result[0] === "") {
        attachedFileRow.classList.add('bg-blue-100')
      }
    }
  }
}
